<template>
<v-dialog
    v-model="dialog"
    fullscreen
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>Send Introduction</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>

                <v-btn
                    dark
                    text
                    @click="onClickCancel"
                >
                    Cancel
                </v-btn>

                <v-icon
                    v-on:click="onClickSettings"
                >
                    mdi-cog-outline
                </v-icon>

            </v-toolbar-items>
        </v-toolbar>

        <v-card-text
            style="padding-top: 15px;"
        >

            <h2>Image</h2>

            <div
                :style="imageCardStyle(item)"
                class="image_card"
                v-for="(item, index) in images"
                :key="index"
                v-on:click="onClickImageCard(item)"
            >
                <img
                    :src="item.logo_image_url"
                    style="width: 300px;"
                />
                <br/>
            </div>

            <div
                style="margin-top: 35px; margin-bottom: 35px; text-align: center"
                v-if="images.length == 0"
            >
                You have not upoaded any introduction images.<br/><br/>
                <v-btn
                    v-on:click="onClickSettings"
                >
                    Introduction Settings...
                </v-btn>
            </div>

            <v-textarea
                label="Message"
                auto-grow
                autofocus
                rows="1"
                v-model="message"
            />

        <div
            style="text-align: right"
        >
            <v-btn
                v-on:click="onClickCustomize"
                style="margin-right: 15px"
            >
                Customize & Attach Other Files...
            </v-btn>

            <v-btn
                color="primary"
                v-on:click="onClickSend"
            >
                Send
            </v-btn>
        </div>

        </v-card-text>

    </v-card>
</v-dialog>
</template>

<script>
const E164 = require('@/js/E164.js');

export default {

    data() {
        return {
            dialog: false,
            images: [],
            logo_image_blob_id: 'no-logo',
            message: 'Your message here',
        }
    },

    methods: {

        showDialog()
        {
            this.dialog = true;
            this.$router.dialog_guard = this.dialogGuard;

            this.logo_image_blob_id = 'no-logo'

            this.$rc.showSpinner();
            
            this.$rc.rest(
                'PUT: /api/v1/introduction/generate',
            
                {
                    'active_endpoint' : E164.fullEndpoint(this.$route.params.endpoint),
                    'conversation_id' : this.$route.params.conversation_id,
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.images = data.images;

                    for ( let i = 0; i < data.images.length; i++ )
                    {
                        if ( data.images[i].is_default == true && data.images[i].logo_image_blob_id != null )
                        {
                            this.logo_image_blob_id = data.images[i].logo_image_blob_id;
                        }
                    }

                    this.message = data.result;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = null;
        },

        onClickCustomize()
        {
            let blob_ids = [];

            if ( this.logo_image_blob_id != null )
                blob_ids.push(this.logo_image_blob_id);

            this.closeDialog();

            this.$emit('customize', {
                'blob_ids': blob_ids,
                'message': this.message,
            });
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.$router.dialog_guard = null;
                return;
            }
        
            this.$router.dialog_guard = null;
            this.dialog = false;
            next(false);
            return;
        },

        onClickCancel()
        {
            this.closeDialog();
        },

        onClickSend()
        {
            this.$rc.showSpinner();

            let blob_ids = '';

            if ( this.logo_image_blob_id != 'no-logo' && this.logo_image_blob_id != null )
            {
                blob_ids = this.logo_image_blob_id;
            }


            this.closeDialog();
            
            this.$rc.rest(
                'POST: /api/v1/messages/send-message',
            
                {
                    'from' : E164.fullEndpoint(this.$route.params.endpoint),
                    'conversation_id' : this.$route.params.conversation_id,
                    'text' : this.message,
                    'blob_ids': blob_ids,
                    'send_images_as_links': false,
                    'category' : 'conversational',
                },
            
                (data) => {
                    this.$rc.hideSpinner();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to send introduction');
                },
            );
        },

        imageCardStyle(item)
        {
            if ( item.logo_image_blob_id == this.logo_image_blob_id )
                return 'display: inline-block; margin: 15px; text-align: center; padding: 15px; border: 3px solid rgba(0,0,0,0.2); border-radius: 10px; cursor: pointer;';
            else
                return 'display: inline-block; margin: 15px; text-align: center; padding: 15px; border: 1px solid rgba(0,0,0,0.2); border-radius: 10px; cursor: pointer;';
        },

        onClickImageCard(item)
        {
            this.logo_image_blob_id = item.logo_image_blob_id;
        },

        onClickSettings(item)
        {
            this.closeDialog();
            this.$router.push({
                'name': 'settings-organization-introductions',
                'params' : {
                    'organization_id': this.$rc.$state.getOrganizationId(),
                }
            });
        },
    },

    computed: {
        branding_with_blob_id() {
            let ret = [];

            for ( let i = 0; i < this.branding.length; i++ )
            {
                let cur = this.branding[i];

                if ( cur.logo_image_blob_id == null ) continue;

                ret.push(cur);
            }

            return ret;
        }
    },
}
</script>

<style lang="scss" scoped>
.image_card
{
}
</style>